import { Component, OnInit } from '@angular/core';
import {ReportService} from 'src/app/services';
import * as Highcharts from 'highcharts';
import {getDateHelper} from "../../../shared/common/helper";
@Component({
  selector: 'app-log-call-repost',
  templateUrl: './log-call-repost.component.html',
  styleUrls: ['./log-call-repost.component.scss']
})
export class LogCallRepostComponent implements OnInit {
  action = 1;
  actionLabel = 'Thống kê cuộc gọi';
  actions = [
    {
      label: 'Thống kê cuộc gọi',
      value: 1
    },
    {
      label: 'Thống kê thời gian cuộc gọi',
      value: 2
    },
    {
      label: 'Thống kê thời gian chờ',
      value: 3
    }
  ];
  dateRange;
  query;
  timeLabel = [];
  value = [];
  titleY = 'Số lượng cuộc gọi';
  statistics: any;
  constructor(
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.loadData();
  }
  actionSelect(event) {
    this.action = event;
    this.loadData();
    this.actions.map(item => {
      if (item.value === this.action) {
        this.actionLabel = item.label;
      }
    });
    if (this.action !== 1) {
      this.titleY = 'Thời gian (s)';
      return;
    }
    this.titleY = 'Số lượng cuộc gọi';
  }
  loadData() {
    this.timeLabel = [];
    this.value = [];
    let from;
    let to;
    if (this.dateRange) {
      from = this.getDate(this.dateRange[0]);
      to = this.getDate(this.dateRange[1]);
    }
    this.query = {
      type: this.action,
    };
    if (from !== undefined && to !== undefined) {
      this.query.from = from;
      this.query.to = to;
    }
    this.reportService.getRepost(this.query).subscribe(res => {
      if (res.code === 1) {
        this.statistics =  res.data.overview;
        this.statistics.sumDurationTime = Math.floor(this.statistics.sumDurationTime / 60);
        this.statistics.sumWaitTime = Math.floor(this.statistics.sumWaitTime / 60);
        this.statistics.averageDuration = Math.floor(this.statistics.averageDuration);
        this.statistics.averageWait = Math.floor(this.statistics.averageWait);
        const data = res.data.data;
        data.map(item => {
          this.timeLabel.push(item.date);
          this.value.push({y: item.data});
        });
      }
      this.highchartsLine();
    }, error => {
      this.highchartsLine();
    });
  }
  search() {
    this.loadData();
  }
  reset() {
    this.action = 1;
    this.dateRange = undefined;
    this.actionLabel = 'Thống kê cuộc gọi';
    this.titleY = 'Số lượng cuộc gọi';
    this.loadData();
  }
  highchartsLine() {
    Highcharts.chart('chartLine', {
      chart: {
        type: 'area',
      },
      title: {
        align: 'left',
        text: ''
      },
      xAxis: {
        categories: this.timeLabel
      },

      yAxis: {
        title: {
          text: `${this.titleY}`
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [{
        name: `${this.actionLabel}`,
        colorByPoint: true,
        data: this.value,
        type: undefined
      }]
    });

  }
  getDate(date) {
    return getDateHelper(date);
  }
}
